let cursorX = -1;
let cursorY = -1;
let cursorVisible = false;

const onPointerMove = (e: PointerEvent) => {
  cursorX = e.clientX;
  cursorY = e.clientY;
  cursorVisible = true;
};

const onPointerLeave = () => {
  cursorVisible = false;
};

const onPointerEnter = () => {
  cursorVisible = true;
};

export const initCursorCapture = (): void => {
  cursorX = -1;
  cursorY = -1;
  cursorVisible = false;
  document.addEventListener("pointermove", onPointerMove);
  document.addEventListener("pointerleave", onPointerLeave);
  document.addEventListener("pointerenter", onPointerEnter);
};

export const drawCursor = (
  ctx: CanvasRenderingContext2D,
  canvasW: number,
  canvasH: number,
): void => {
  if (!cursorVisible || cursorX < 0 || cursorY < 0) {
    return;
  }

  const dpr = window.devicePixelRatio;
  const x = cursorX * dpr;
  const y = cursorY * dpr;

  if (x > canvasW || y > canvasH) {
    return;
  }

  ctx.save();

  // Outer glow aura
  const glowRadius = 18 * dpr;
  const gradient = ctx.createRadialGradient(x, y, 0, x, y, glowRadius);
  gradient.addColorStop(0, "rgba(255, 60, 60, 0.35)");
  gradient.addColorStop(0.5, "rgba(255, 80, 80, 0.12)");
  gradient.addColorStop(1, "rgba(255, 80, 80, 0)");
  ctx.beginPath();
  ctx.arc(x, y, glowRadius, 0, Math.PI * 2);
  ctx.fillStyle = gradient;
  ctx.fill();

  // Inner core dot
  const coreRadius = 5 * dpr;
  ctx.beginPath();
  ctx.arc(x, y, coreRadius, 0, Math.PI * 2);
  ctx.fillStyle = "rgba(255, 80, 80, 0.85)";
  ctx.fill();
  ctx.strokeStyle = "rgba(255, 255, 255, 0.5)";
  ctx.lineWidth = 1.5 * dpr;
  ctx.stroke();

  ctx.restore();
};

export const cleanupCursorCapture = (): void => {
  document.removeEventListener("pointermove", onPointerMove);
  document.removeEventListener("pointerleave", onPointerLeave);
  document.removeEventListener("pointerenter", onPointerEnter);
  cursorX = -1;
  cursorY = -1;
  cursorVisible = false;
};
